// Audio Manager using Howler.js
import { Howl, Howler } from 'howler';

const audioBase = `${process.env.PUBLIC_URL || ''}/assets/audio`;
const audioSrc = (file: string) => `${audioBase}/${file}`;

export const sounds = {
  chipClink: new Howl({ src: [audioSrc('chip-clink.mp3')], volume: 0.7 }),
  cardSlide: new Howl({ src: [audioSrc('card-slide.mp3')], volume: 0.5 }),
  cardFlip: new Howl({ src: [audioSrc('card-flip.mp3')], volume: 0.5 }),
  potCollect: new Howl({ src: [audioSrc('pot-collect.mp3')], volume: 0.7 }),
  allIn: new Howl({ src: [audioSrc('all-in.mp3')], volume: 0.8 }),
  win: new Howl({ src: [audioSrc('win.mp3')], volume: 0.8 }),
  ambient: new Howl({ src: [audioSrc('ambient-casino.mp3')], loop: true, volume: 0.3 }),
};

export function playSound(name: keyof typeof sounds) {
  sounds[name]?.play();
}

export function stopSound(name: keyof typeof sounds) {
  sounds[name]?.stop();
}

export async function resumeAudioContext() {
  try {
    const ctx = (Howler as any).ctx as AudioContext | undefined;
    if (ctx && ctx.state === 'suspended') {
      await ctx.resume();
    }
  } catch (err) {
    // ignore resume failures
  }
}
